import type { BannerItem as HomeSliderType } from '@/types'
import Link from 'next/link'
import { useEffect, useRef } from 'react'
import type SliderType from 'react-slick'
import type { Settings } from 'react-slick'
import ImageOptimize from '../ImageOptimize'
import Slider from '../Slider/Slider'

interface HomeSliderProps {
  sliders: Array<HomeSliderType>
}

export const HomeSlider = ({ sliders }: HomeSliderProps) => {
  const sliderSettings: Settings = {
    autoplay: true,
    dots: false,
    autoplaySpeed: 5000,
    arrows: true,
    fade: true,
    speed: 300,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
  }
  const ref = useRef<SliderType>(null)

  useEffect(() => {
    if (sliders?.length) {
      handleAfterChange(0)
    }
  }, [sliders])

  const handleBeforeChange = () => {
    const homeSliderBg = document.getElementById(
      'home-slider-bg'
    ) as HTMLElement
    if (homeSliderBg) {
      homeSliderBg.style.opacity = '0'
    }
  }

  const handleAfterChange = (currentIndex: number) => {
    const homeSliderBg = document.getElementById(
      'home-slider-bg'
    ) as HTMLElement

    if (homeSliderBg) {
      homeSliderBg.style.backgroundImage = `url('${sliders[currentIndex].bgImage}')`
      homeSliderBg.style.opacity = '1'
    }
  }

  return (
    !!sliders && (
      <section
        className={`homeSlider relative z-0 w-full pt-12 ${
          !sliders ? 'hidden' : ''
        }`}
      >
        <div
          id='home-slider-bg'
          className='-z-1 absolute -mt-12 h-vh w-full bg-contain bg-no-repeat opacity-0 transition-opacity duration-300 ease-in'
        />
        <div className='container mx-auto px-10'>
          <Slider
            ref={ref}
            {...sliderSettings}
            className='max-w-screen slickHome flex h-[280px] px-10'
            afterChange={handleAfterChange}
            beforeChange={handleBeforeChange}
          >
            {sliders.map((slider: HomeSliderType, index: number) => (
              <Link href={slider?.link || '/'} key={index}>
                <ImageOptimize
                  className='h-[280px] w-full bg-contain'
                  src={slider?.image}
                  alt={slider?.title}
                  width={1312}
                  height={480}
                  priority
                />
              </Link>
            ))}
          </Slider>
        </div>
      </section>
    )
  )
}
